import { useField } from "formik";
import React, { FunctionComponent } from "react";

export interface Props {
  name: string;
}

export const FormGroup: FunctionComponent<Props> = ({ children, name }) => {
  const [, { error }] = useField(name);
  return (
    <div className={`form-group ${error ? "has-error" : ""}`}>
      {children}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

FormGroup.displayName = "FormGroup";
